module.exports = __webpack_public_path__ + "img/annotation-examples.580d0256.png";